export const DEAL_NOTIFICATION_TYPES = ['claim', 'deal', 'debtor'];
export const ENTER_KEYS = [',', ';', ' '];
